import { ExclamationIcon } from "@heroicons/react/solid";
import React from "react";

interface Props {
  error: string;
}

const ErrorComponent = (props: Props) => {
  return (
    <div className="rounded-md bg-yellow-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationIcon
            className="h-5 w-5 text-yellow-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-900">Attention!</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>{props.error}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
